/**
 * Paginacion de un listado.
 *
 * Son enlaces `<a>` con su URL completa, no botones: es la unica forma de que
 * un robot recorra el catalogo entero y de que el comprador pueda compartir o
 * guardar la pagina 3 de una categoria (SEO-01).
 */
import { Link } from 'react-router-dom';

import { conPagina } from '../../utilidades/rutas';
import { Icono } from '../comunes/Icono';

/** Cuantos numeros se muestran alrededor de la pagina actual. */
const VENTANA = 2;

export interface PaginadorProps {
  pagina: number;
  total: number;
  porPagina: number;
  /** Ruta base del listado, sin el numero de pagina. */
  ruta: string;
}

function rango(actual: number, ultima: number): number[] {
  const desde = Math.max(1, Math.min(actual - VENTANA, ultima - VENTANA * 2));
  const hasta = Math.min(ultima, Math.max(actual + VENTANA, VENTANA * 2 + 1));
  const numeros: number[] = [];
  for (let n = desde; n <= hasta; n++) numeros.push(n);
  return numeros;
}

export function Paginador({ pagina, total, porPagina, ruta }: PaginadorProps) {
  const ultima = Math.max(1, Math.ceil(total / porPagina));
  if (ultima <= 1) return null;

  return (
    <nav className="paginador" aria-label="Paginas de resultados">
      {pagina > 1 ? (
        <Link to={conPagina(ruta, pagina - 1)} rel="prev" aria-label="Pagina anterior">
          <Icono nombre="flechaIzq" />
        </Link>
      ) : (
        <span className="inerte" aria-hidden="true">
          <Icono nombre="flechaIzq" />
        </span>
      )}

      {rango(pagina, ultima).map((numero) =>
        numero === pagina ? (
          <span key={numero} aria-current="page">
            {numero}
          </span>
        ) : (
          <Link key={numero} to={conPagina(ruta, numero)} aria-label={`Pagina ${numero}`}>
            {numero}
          </Link>
        ),
      )}

      {pagina < ultima ? (
        <Link to={conPagina(ruta, pagina + 1)} rel="next" aria-label="Pagina siguiente">
          <Icono nombre="flecha" />
        </Link>
      ) : (
        <span className="inerte" aria-hidden="true">
          <Icono nombre="flecha" />
        </span>
      )}
    </nav>
  );
}
